import gql from 'graphql-tag';

export const ACCEPT_REJECT_CONVERSION = gql`
mutation AcceptAndRejectAffiliateConversion($action: CONVERSION_ACTION!, $data: [AcceptRejectInput!]!) {
  acceptAndRejectAffiliateConversion(action: $action, data: $data)
}

`;
